/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { Fragment } from 'react';

import moment from 'moment';

import { EFormatData } from '../../../../../pages/PageDashboard/types/widgetTypes';
import { formatBalance } from '../../../../../utils/formatText';
import { getTimeZone } from '../../../utils/getTimezone';
import { TableCellBalanceDateStyled, TableCellBalanceType, TableCellBalanceValueStyled } from './styled';

interface TableCellBalance {
    currency?: string;
    date?: string;
    value: number;
    // value > 0 - зеленый, value < 0 - красный
    noHighlight?: boolean;
}

const BalanceCell = ({ currency, date, value, noHighlight }: TableCellBalance) => {

    let balanceType: TableCellBalanceType = 'default';
    if (!noHighlight && +value > 0) {
        balanceType = 'positive';
    } else if (!noHighlight && +value < 0) {
        balanceType = 'negative';
    }

    return (
        <Fragment>
            <TableCellBalanceValueStyled type={balanceType}>
                {formatBalance(value)}
                {currency && <span className="currency">{currency}</span>}
            </TableCellBalanceValueStyled>
            {date && (
                <TableCellBalanceDateStyled>
                    {moment(date).format(EFormatData.FullDateWithTime)} {getTimeZone(date)}
                </TableCellBalanceDateStyled>
            )}
        </Fragment>
    );
};

export default BalanceCell;
